__webpack_require__.p = "/splat3seedchecker/";